import { colors, transitions, fonts, spacing, shadows } from './styles';

// --------------------------------------------------------------------------------
// 📌  Default configuration for the application
// --------------------------------------------------------------------------------

export const config = {
  ...colors,
  ...transitions,
  ...fonts,
  ...spacing,
  ...shadows,
};
